import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const CatalogPreviewItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  description: z.string().nullable(),
  kind: z.string(),
  grain: z.string().nullable(),
  details: z.unknown(),
});

export const getCustomAnalyticsCatalogPreview = unaryRpc({
  name: "getCustomAnalyticsCatalogPreview" as const,
  input: z.object({}),
  output: z.object({
    version: z.string(),
    sections: z.array(
      z.object({
        id: z.string(),
        title: z.string(),
        description: z.string(),
        count: z.number().int().min(0),
        items: z.array(CatalogPreviewItemSchema),
      }),
    ),
  }),
});

export type GetCustomAnalyticsCatalogPreviewInput = z.infer<
  typeof getCustomAnalyticsCatalogPreview.input
>;
export type GetCustomAnalyticsCatalogPreviewOutput = z.infer<
  typeof getCustomAnalyticsCatalogPreview.output
>;
